import { render, staticRenderFns } from "./NewLocationModal.vue?vue&type=template&id=54b7748c&scoped=true"
import script from "./NewLocationModal.vue?vue&type=script&lang=js"
export * from "./NewLocationModal.vue?vue&type=script&lang=js"
import style0 from "./NewLocationModal.vue?vue&type=style&index=0&id=54b7748c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b7748c",
  null
  
)

export default component.exports